export default __webpack_public_path__ + "static/BrokerBackground2024-b9a33866aa4e615e0bde104f3992e244.jpg";